window.$ = jQuery;

const Combos = (function() {
    $(".post-carousel").each(function() {
        if ($(this).prev().is(".feature-category")) {
            $(this).prev().addClass("no-bottom-border");
        }
    })
    $("#jp-relatedposts").remove();
})();

export default Combos;